import { useAtomValue } from 'jotai';
import { useCollectionTreeQuery } from 'lib-knowledge-management-common/graphql';
import { collectionIdAtom } from 'models/collectionStore';

type UseCollectionTreeReturnValue = ReturnType<typeof useCollectionTreeQuery>;

function useCollectionTreeFetch({
  collectionId,
}: {
  collectionId?: string;
} = {}): UseCollectionTreeReturnValue {
  const globalCollectionId = useAtomValue(collectionIdAtom);

  return useCollectionTreeQuery({
    variables: {
      id: collectionId || globalCollectionId || '',
    },
    skip: !collectionId && !globalCollectionId,
    fetchPolicy: 'cache-and-network',
    // This is needed to make sure Apollo updates after a category move.
    returnPartialData: true,
  });
}

export default useCollectionTreeFetch;
